import { render, staticRenderFns } from "./AddOnChargesForm.vue?vue&type=template&id=022e1289&"
import script from "./AddOnChargesForm.vue?vue&type=script&lang=js&"
export * from "./AddOnChargesForm.vue?vue&type=script&lang=js&"
import style0 from "./AddOnChargesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports